import slick from 'slick-carousel';

jQuery( '.js-tabs-nav' ).slick( {
	rows: 0,
	slidesToShow: 1,
	infinite: false,
	arrows: false,
	focusOnSelect: true,
	mobileFirst: true,
	variableWidth: true,
	responsive: [
		{
			breakpoint: 576,
			settings: {
				slidesToShow: 2,
			}
		},
		{
			breakpoint: 768,
			settings: 'unslick',
		},
	]
} );
